import { useState } from 'react';

export default function MilitaryFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Do I really not need a DD-214 or any proof of service?',
      answer:
        'Correct. We take your word for it. Show us your military ID, tell us you served, or just ask about the Dog Tag Discount — no paperwork required. We\'re not here to verify; we\'re here to thank you.',
    },
    {
      question: 'Who qualifies for the Dog Tag Discount?',
      answer:
        'Active duty military, veterans, reservists, National Guard members, and military spouses all qualify. First responders — including police officers, firefighters, EMTs, paramedics, and 911 dispatchers — are also fully included. If you\'ve served your country or your community, you\'re eligible.',
    },
    {
      question: 'Do police officers and firefighters qualify?',
      answer:
        'Yes, absolutely. Law enforcement officers, firefighters, and fire & rescue personnel are fully eligible for the Dog Tag Discount. We believe those who run toward danger — in uniform or in gear — deserve the same recognition as those who serve in the military.',
    },
    {
      question: 'Do EMTs and paramedics qualify?',
      answer:
        'Yes. EMTs, paramedics, and emergency medical responders qualify for the full $300 Dog Tag Discount. Your work saves lives every day — the least we can do is save you money on your next vehicle.',
    },
    {
      question: 'Do 911 dispatchers qualify?',
      answer:
        'Yes. 911 dispatchers are the first link in every emergency response chain. They qualify for the Dog Tag Discount just like any other first responder. No badge required — just let us know when you inquire.',
    },
    {
      question: 'What proof do first responders need to provide?',
      answer:
        'None, technically. We operate on the honor system. If you\'d like to show a badge, department ID, or work email, that\'s welcome — but it\'s never required. We trust you.',
    },
    {
      question: 'Can I donate the $300 instead of using it as a discount?',
      answer:
        'Absolutely. If you\'d rather pay it forward, we\'ll donate the full $300 to Oregon Dog Rescue on your behalf. You can choose when you inquire.',
    },
    {
      question: 'Does the Dog Tag Discount apply to all vehicles?',
      answer:
        'Yes. The $300 discount applies to any vehicle in our inventory, regardless of price. No exclusions, no fine print.',
    },
    {
      question: 'Can I combine the Dog Tag Discount with other offers?',
      answer:
        'The Dog Tag Discount is a standalone offer and cannot be combined with other promotions. However, it applies on top of our already competitive pricing.',
    },
    {
      question: 'How do I claim the Dog Tag Discount?',
      answer:
        'Just fill out the inquiry form on this page or mention it when you contact us. We\'ll apply the discount when you\'re ready to purchase.',
    },
    {
      question: 'Is there a limit to how many times I can use the Dog Tag Discount?',
      answer:
        'The discount applies once per vehicle purchase. If you\'re buying multiple vehicles or returning for another purchase, just let us know — we\'ll work with you.',
    },
    {
      question: 'What if I\'m a military spouse?',
      answer:
        'Military spouses qualify for the Dog Tag Discount. Just let us know when you inquire, and we\'ll take care of the rest.',
    },
    {
      question: 'Why does Rockhound offer the Dog Tag Discount?',
      answer:
        'Because we believe in thanking those who\'ve served — without the bureaucracy. That means military, veterans, and every first responder who puts on a uniform to protect and serve their community. Dealerships treat these discounts like a favor. We treat it like a duty.',
    },
    {
      question: 'Can I use the Dog Tag Discount if I\'m buying from out of state?',
      answer:
        'Yes. The Dog Tag Discount applies to all buyers, regardless of location. We deliver across Oregon and Southwest Washington.',
    },
  ];

  return (
    <section className="py-16 lg:py-24 bg-slate-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-4">
            Dog Tag Discount FAQ
          </h2>
          <p className="text-xl text-slate-600">
            Common questions about the Dog Tag Discount — for military, veterans, and first responders.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="border border-slate-200 rounded-xl overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-6 text-left hover:bg-slate-50 transition-colors cursor-pointer"
              >
                <span className="font-semibold text-slate-900 pr-4">
                  {faq.question}
                </span>
                <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-xl text-slate-400 flex-shrink-0`}></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-6">
                  <p className="text-slate-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 bg-slate-50 rounded-xl p-8 text-center">
          <h3 className="text-xl font-bold text-slate-900 mb-3">
            Still Have Questions?
          </h3>
          <p className="text-slate-600 mb-6">
            Our team is here to help you understand and claim your Dog Tag Discount.
          </p>
          <a 
            href="/contact" 
            className="inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-800 text-white px-6 py-3 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer"
          >
            Contact Us
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}